/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  constants for traktor-middleware
 */

import { STACK_NAME, getLiveEnv } from '@zcode/env'
import { switchSetting } from '@zcode/settings'

export const EVENT = '@@zumper/traktor-middleware/EVENT'
export const LOCAL_FAVORITES_SYNC = 'LOCAL_FAVORITES_SYNC'
export const SESSION = 'SESSION'
export const SIGNUP = 'SIGNUP'
export const PADMAPPER = 2
export const ZUMPER = 1

const traktorApiUrl = getLiveEnv(
  'TRAKTOR_API_GATEWAY_URL',
  'https://prod-main-datapipeline.zumper.com/events'
)
export const TRAKTOR_API_GATEWAY_URL = switchSetting(
  traktorApiUrl,
  traktorApiUrl.replace('://prod-main', `://test-${STACK_NAME}`),
  traktorApiUrl.replace('://prod', '://test')
)
